/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateProjectForm,
  UpdateProjectForm$Outbound,
  UpdateProjectForm$outboundSchema,
} from "../components/updateprojectform.js";

export type UpdateProjectSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateProjectRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateProjectForm: UpdateProjectForm;
};

/** @internal */
export type UpdateProjectSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateProjectSecurity$outboundSchema: z.ZodMiniType<
  UpdateProjectSecurity$Outbound,
  UpdateProjectSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateProjectSecurityToJSON(
  updateProjectSecurity: UpdateProjectSecurity,
): string {
  return JSON.stringify(
    UpdateProjectSecurity$outboundSchema.parse(updateProjectSecurity),
  );
}

/** @internal */
export type UpdateProjectRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateProjectForm: UpdateProjectForm$Outbound;
};

/** @internal */
export const UpdateProjectRequest$outboundSchema: z.ZodMiniType<
  UpdateProjectRequest$Outbound,
  UpdateProjectRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateProjectForm: UpdateProjectForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateProjectForm: "UpdateProjectForm",
    });
  }),
);

export function updateProjectRequestToJSON(
  updateProjectRequest: UpdateProjectRequest,
): string {
  return JSON.stringify(
    UpdateProjectRequest$outboundSchema.parse(updateProjectRequest),
  );
}
